<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. قسم التحكم والبحث (يختفي عند الطباعة) -->
    <div class="card mb-4 no-print">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">إحصاء عددي للمجموعات (كنترول)</h5>
      </div>

      <div class="card-body">
        <!-- صف الاختيارات -->
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label fw-bold">الفصل الدراسي</label>
            <select
              @change="getSubjectswithtearm(form.term)"
              v-model="form.term"
              class="form-control"
            >
              <option value="">اختر الفصل الدراسي</option>
              <option v-for="t in terms" :key="t.id" :value="t">
                {{ t.name }}
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">المادة</label>
            <select v-model="form.subject" class="form-control">
              <option value="">اختر المادة</option>
              <option v-for="s in subjects" :key="s.id" :value="s">
                {{ s.name }}
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">المجموعة</label>
            <select v-model="form.group" class="form-control">
              <option value="">اختر المجموعة</option>
              <option v-for="g in groups" :key="g.id" :value="g.id">
                {{ g.group_name }}
              </option>
            </select>
          </div>
        </div>

        <!-- الأزرار -->
        <div class="d-flex justify-content-end mt-4 flex-wrap gap-2">
          <button @click="getStudentWithAbs" class="btn btn-warning text-dark mx-1 mb-2">
            <i class="fas fa-search"></i> استعلام عن غياب الطلاب
          </button>
          
          <button @click="print" class="btn btn-info text-white mx-1 mb-2">
            <i class="fas fa-print"></i> طباعة الإحصاء
          </button>
        </div>
      </div>
    </div>

    <!-- رسائل التنبيه -->
    <div v-if="message" class="alert alert-success alert-dismissible fade show mt-3 no-print">
      {{ message }}
    </div>

    <!-- 2. قسم التقرير (يظهر عند الطباعة أو وجود بيانات) -->
    <!-- نستخدم شرط للتأكد من وجود كائن Student لتجنب الأخطاء -->
    <div v-if="Student" class="print-area" id="printMe">
      
      <!-- ترويسة التقرير -->
      <div class="report-header mb-4 text-center border-bottom pb-3">
        <div class="row align-items-center">
          <div class="col-4 text-start">
             <p class="mb-1"><strong>الكنترول المركزي</strong></p>
             <p class="mb-0"><strong>الغرفة السرية</strong></p>
          </div>
          <div class="col-4 text-center">
            <h3 class="mb-2">إحصاء عددي للمجموعة</h3>
            <span class="badge bg-secondary fs-6">{{ form.term ? form.term.name : '' }}</span>
          </div>
          <div class="col-4 text-center">
             <p class="mb-1"><strong>المادة:</strong> {{ form.subject ? form.subject.name : '---' }}</p>
             <p class="mb-0"><strong>المجموعة:</strong> {{ form.group }}</p>
          </div>
        </div>
      </div>

      <!-- جدول الإحصاء -->
      <div class="table-responsive">
        <table class="table table-bordered table-hover align-middle text-center table-report">
          <thead class="table-light">
            <tr>
              <th style="width: 20%">البيان / نوع الأوراق</th>
              <th style="width: 60%">الأرقام السرية</th>
              <th style="width: 20%">العدد</th>
            </tr>
          </thead>
          <tbody>
            <!-- الغياب -->
            <tr>
              <td class="fw-bold">الغياب</td>
              <td>
                <div class="d-flex flex-wrap justify-content-center gap-1">
                  <span v-for="(abs, index) in Student.student_abs" :key="'abs'+index" class="badge bg-danger fs-5">
                    {{ abs.SecretKey }}
                  </span>
                </div>
              </td>
              <td class="fw-bold fs-5">{{ Student.student_abs ? Student.student_abs.length : 0 }}</td>
            </tr>

            <!-- لغات -->
            <tr>
              <td class="fw-bold">لغات</td>
              <td>
                <div class="d-flex flex-wrap justify-content-center gap-1 fs-5">
                  <span v-for="(lang, index) in Student.student_lang" :key="'lang'+index" class="badge bg-primary fs-5">
                    {{ lang.SecretKey }}
                  </span>
                </div>
              </td>
              <td class="fw-bold fs-5">{{ Student.student_lang ? Student.student_lang.length : 0 }}</td>
            </tr>

            <!-- دمج -->
            <tr>
              <td class="fw-bold">طلاب دمج</td>
              <td>
                <div class="d-flex flex-wrap justify-content-center gap-1 fs-5">
                  <span v-for="(damge, index) in Student.student_damge" :key="'damge'+index" class="badge bg-warning text-dark fs-5">
                    {{ damge.SecretKey }}
                  </span>
                </div>
              </td>
              <td class="fw-bold fs-5">{{ Student.student_damge ? Student.student_damge.length : 0 }}</td>
            </tr>

            <!-- لجنة خاصة -->
            <tr>
              <td class="fw-bold">لجنة خاصة</td>
              <td>
                <div class="d-flex flex-wrap justify-content-center gap-1 fs-5">
                  <span v-for="(khas, index) in Student.student_khas" :key="'khas'+index" class="badge bg-info text-dark fs-5">
                    {{ khas.SecretKey }}
                  </span>
                </div>
              </td>
              <td class="fw-bold fs-5">{{ Student.student_khas ? Student.student_khas.length : 0 }}</td>
            </tr>

            <!-- الدين المسيحي -->
            <tr>
              <td class="fw-bold">الدين المسيحي</td>
              <td>---</td> <!-- يمكنك وضع الأرقام هنا إذا توفرت -->
              <td class="fw-bold"></td> <!-- القيمة الثابتة كما في كودك -->
            </tr>

            <!-- الإجماليات -->
            <tr class="table-secondary">
              <td colspan="2" class="text-center fw-bold ps-4">إجمالي (خارج الورق / المستبعد)</td>
              <td class="fw-bold text-danger fs-5">{{ totalStudents }}</td>
            </tr>

            <tr class="table-success">
              <td colspan="2" class="text-center fw-bold ps-4">إجمالي الورق (المتبقي للتصحيح)</td>
              <td class="fw-bold text-success fs-5">{{ 200 - totalStudents }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- تذييل التقرير -->
      <div class="report-footer mt-4 text-start text-muted fs-6">
        * تم توليد التقرير بواسطة نظام إدارة الكنترول
      </div>
    </div>

  </div>
</template>


<script>
import api from "../../api/axios";
export default {
  data() {
    return {
      message: "",
      subjects: [],
      terms: [],
      groups: [],
      Student: [],

      form: {
        Seating_No: "",
        subject: "",
        term: "",
        group: "",
      },
    };
  },
  computed: {
  totalStudents() {
    return Object.values(this.Student)
      .reduce((sum, arr) => sum + arr.length, 0);
  }
},

  mounted() {
    api.get("/getterms").then((res) => {
      this.terms = res.data;
    });

    api.get("/getgroups").then((res) => {
      this.groups = res.data;
    });
  },

  methods: {
    getSubjectswithtearm(id) {
      api.get("/getSubject/" + id.id).then((res) => {
        this.subjects = res.data;
        this.getStudentWithAbs();
      });
    },
    
  
    getStudentWithAbs() {
      api
        .post("/countStatistics", this.form)
        .then((res) => {
          this.Student = res.data['0'];
        })
        .catch((e) => {});
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe", () => {
        console.log("Printing done or got cancelled!");
      });
    },
  },
};
</script>

<style scoped>
.container {
  direction: rtl;
  text-align: right;
}

.report-container {
  width: 100%;
  padding: 20px;
  font-family: "Cairo", sans-serif;
  color: #222;
}

.report-header {
  text-align: center;
  margin-bottom: 25px;
}

.report-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}

.report-header .sub {
  font-size: 14px;
  color: #555;
}

.table-report {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 15px;
}

.table-report thead {
  background: #f1f1f1;
}

.table-report th {
  padding: 10px 8px;
  text-align: center;
  border: 1px solid #ccc;
  font-weight: 700;
}

.table-report td {
  padding: 9px 6px;
  border: 1px solid #ddd;
  text-align: center;
}

.table-report tbody tr:nth-child(even) {
  background: #fafafa;
}

.table-report tbody tr:hover {
  background: #eef5ff;
}

.footer-note {
  margin-top: 30px;
  text-align: left;
  font-size: 13px;
  color: #777;
}
</style>